import { Space, Avatar, Tag, Tooltip, Typography, Image } from "antd";
import Icon, { MobileTwoTone, UserOutlined } from "@ant-design/icons";
import { useRef } from 'react';
import BackupIcon from '../../assets/backup.svg';
import QuizIcon from '../../assets/quiz.svg';
import VipIcon from '../../assets/vip.png';

const UserInfoView = ({ user, showWallet = false, simple = false }) => {
    const tooltipRef = useRef(null);
    if (!user) return <div />;
    let src = user.picture ?? user.avatar;
    const { phoneNumber, backupWallet, isQuizz, isProActive } = user;

    console.log('user isProActive', isProActive);

    const buildAddressView = () => {
        if (!showWallet) return <div />;
        let address = user.addressList;
        if (!address || address.length <= 0) {
            return <Tag color="warning" style={{ fontSize: 11 }}>No Wallet</Tag>
        }
        return (
            <Space size={4}>

                {
                    address.map((item, index) => {
                        return (
                            <div key={index}>
                                <Tooltip
                                    ref={tooltipRef}
                                    title={
                                        <Typography.Text copyable style={{ maxWidth: 100, fontSize: 12 }} ellipsis>
                                            {item.address}
                                        </Typography.Text>
                                    }
                                    color="white"
                                    trigger={'click'}>
                                    <div>
                                        {item.symbol === 'BTC' && <img alt="wallet" src="/images/btc.svg" style={{ width: 16, height: 'auto', cursor: 'pointer' }} />}
                                        {item.symbol === 'ETH' && <img alt="wallet" src="/images/eth.svg" style={{ width: 16, height: 'auto', cursor: 'pointer' }} />}
                                        {(item.symbol === 'MATIC' || item.symbol === 'POL') && <img alt="wallet" src="/images/matic.svg" style={{ width: 16, height: 'auto', cursor: 'pointer' }} />}
                                    </div>
                                </Tooltip>
                            </div>
                        )
                    })
                }
            </Space>
        )
    }
    if (simple) {
        return (
            <Space size={4}>
                <div>
                    <div>
                        <Space align="center" size={4}>
                            <b>{user.username ? user.username : user.name}</b>
                            {phoneNumber && (
                                <Tooltip
                                    ref={tooltipRef}
                                    title={
                                        <Typography.Text copyable style={{ maxWidth: 100, fontSize: 12 }} ellipsis>
                                            {phoneNumber}
                                        </Typography.Text>
                                    }
                                    color="white"
                                    trigger={'click'}>
                                    <MobileTwoTone size={16} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                    <div>{buildAddressView()}</div>
                </div>
            </Space>
        )
    }
    return (
        <Space size={4}>
            {
                user.admin ?
                    <Avatar size={showWallet ? 48 : 32} style={{ backgroundColor: 'blue' }}>Admin</Avatar>
                    :
                    (
                        src ?
                            <Avatar size={showWallet ? 48 : 32} src={src} />
                            :
                            <Avatar size={showWallet ? 48 : 32} icon={<UserOutlined />} style={{ backgroundColor: '#87d068' }} />
                    )
            }
            <div>
                <div>
                    <Space align="center" size={4}>
                        <b>{user.name ? user.name : user.email}</b>
                        {phoneNumber && (
                            <Tooltip
                                ref={tooltipRef}
                                title={
                                    <Typography.Text copyable style={{ maxWidth: 100, fontSize: 12 }} ellipsis>
                                        {phoneNumber}
                                    </Typography.Text>
                                }
                                color="white"
                                trigger={'click'}>
                                <MobileTwoTone size={16} />
                            </Tooltip>
                        )}
                        {
                            backupWallet &&
                            <Image preview={false} src={BackupIcon} style={{ height: 14, width: 'auto', position: 'relative', top: -2 }} />
                        }
                        {
                            isQuizz &&
                            <Image preview={false} src={QuizIcon} style={{ height: 14, width: 'auto', position: 'relative', top: -2 }} />
                        }
                        {
                            isProActive && 
                            <Image preview={false} src={VipIcon} style={{ height: 16, width: 'auto', position: 'relative', top: -2 }} />
                        }
                    </Space>
                    <div style={{ color: '#afafaf', fontSize: 12 }}>{user.name ? user.email : ''}</div>
                </div>
                <div>{buildAddressView()}</div>
            </div>
        </Space>
    )
}

export default UserInfoView;